import React from 'react'

import Content, { Theme as ContentTheme } from 'components/base/Content'
import Title from 'components/base/Title'
import ButtonRow from 'components/base/Button/Row'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import Form from 'components/base/Form'
import { Type as InputType } from 'components/base/Form/Input'
import InputGroup from 'components/base/Form/InputGroup'
import FormColumns from 'components/base/Form/Columns'
import RadioOption from 'components/base/Form/Input/Radio/Option'
import SectionDivider from 'components/base/SectionDivider'
import { QuoteIconCreditCard } from 'components/base/Icon/styles'
import CarrierQuoteResult from 'components/blocks/CarrierQuoteResult'
import CarrierLogo, { Theme as CarrierLogoTheme } from 'components/blocks/CarrierLogo'
import QuotingWrapper, { Theme as QuotingWrapperTheme } from 'components/blocks/QuotingWrapper'
import ProgressBar, { Type as ProgressBarType } from 'components/blocks/ProgressBar'

const QuotingPricing: React.FC = (): React.ReactElement => (
  <QuotingWrapper noPadding={true} theme={QuotingWrapperTheme.auto}>
    <ProgressBar type={ProgressBarType.autoRc2} current='completepolicy' />

    <Title level={3}>
      Awesome!
      <br />
      Your report looks great. Your final policy price is below.
    </Title>
    <Content margined={true}>
      <CarrierQuoteResult logo={<CarrierLogo theme={CarrierLogoTheme.safeco} />} monthly={9800} />
    </Content>
    <Content theme={ContentTheme.blue} center={true}>
      <Title level={3}>
        You will be billed $98/mo on the first of the month after your policy
        is issued.
      </Title>
    </Content>
    <Content margined={true}>
      <SectionDivider icon={<QuoteIconCreditCard />} title='Payment Info' />
      <Form>
        <InputGroup
          label='Payment Type'
          type={InputType.radio}
          name='PaymentType'
          defaultValue='cc'
          rules='required'
        >
          <RadioOption value='cc'>Credit Card</RadioOption>
          <RadioOption value='eft'>
            Electronic Funds Transfer (EFT)
          </RadioOption>
        </InputGroup>
        <InputGroup
          type={InputType.text}
          label='Credit Card Number'
          name='ccNumber'
          rules='required'
        />
        <FormColumns>
          <InputGroup
            type={InputType.text}
            label='Expiration Date'
            name='expirationDate'
            rules='required'
          />
          <InputGroup
            type={InputType.text}
            label='CCV'
            name='ccv'
            rules='required'
          />
        </FormColumns>
        <InputGroup
          type={InputType.text}
          label='Billing Zip Code'
          name='billingZipCode'
          rules='required'
        />
        <ButtonRow>
          <Link center={true} wide={true} theme={LinkTheme.button} to='/quote/new/signature'>
            Next
          </Link>
        </ButtonRow>
      </Form>
    </Content>
  </QuotingWrapper>
)

export default QuotingPricing
